// extracted by mini-css-extract-plugin
export default {"table":"ClientHealth_table__1lBrH"};